export default "/assets/images/air3-nav-menu.fa4f3d26118c8237.jpg";